import {debounce, map, xor} from 'helpers';
import {store} from 'store';
import {set} from 'store/settings';

export function toggleQuestion({ id }, event) {
  set({
    module: 'today',
    key: 'diaryQuestionsBlacklist',
    value: blacklist => xor(blacklist, [ id ]),
  })
  event && event.stopPropagation();
}

export const checkInUpdate = debounce(({ type, date, questions, answers, id }) => {
  const text = map(answers, (answer, name) => {
    return answer && questions[name] + '\n' + answer;
  }).filter(Boolean).join('\n\n');
  store.dispatch({
    type: 'DIARY_CHECK_IN',
    ignorePermissions: true,
    answers,
    checkInType: type,
    date,
    id,
    text,
  });
}, 1000);

export function updateQuestion({ id, key, questionType, popup }) {
  store.dispatch({
    type: 'QUESTIONS_UPDATE',
    id,
    key,
    questionType,
  });
  popup?.close();
}

export function deleteQuestion({ id }) {
  store.dispatch({
    type: 'QUESTIONS_DELETE',
    id,
  });
}
